import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Constants } from '../constants';
import { FaMapMarkerAlt } from "react-icons/fa";
import { Box, Button, CardActionArea } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { CustomTooltip } from '../utils/CustomTooltip';
import { MovingText } from '../utils/MovingText';
import { useNavigate } from 'react-router-dom';

const LatestEventCard = ({ item }) => {
    console.log(item,"item")
    const navigate = useNavigate()
    const { event_name, event_price, id, thumbnail, event_venue,event_available_seats } = item
    return (
        <Card sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", my: 1, borderRadius: "40px", bgcolor: "primary.light", width: "100%", }}>
            <CardActionArea onClick={() => navigate(`/EventDetail/${id}`)} sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "start" }} >
                <CardContent
                    sx={{
                        backgroundImage: `linear-gradient(181.43deg, rgba(0, 0, 0, 0) 52.1%, #000000 98.78%),
                       url(https://stage.myskool.club/events/assets/admin/img/event/thumbnail/${thumbnail})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "200px",
                        width: "100%",
                        borderTopRightRadius: "40px",
                        borderTopLeftRadius: "40px",
                        py: { xs: 2, lg: 3 },
                        px: { xs: 2, lg: 5 }
                    }}
                >

                    <CustomTooltip number={event_available_seats} />

                </CardContent>
                <CardContent sx={{ py: 3, px: 5, width: { xs: "95%", lg: "80%" } }} >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, width: "100%" }}>
                        {/* First child - takes remaining space */}
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                            <MovingText text={event_name} />
                            <Box mt={0.5} sx={{ display: "flex", alignItems: "center" }}>
                                <FaMapMarkerAlt style={{ color: "#DC143C", fontSize: "16px", margin: "0 5px 0 0" }} />
                                <MovingText text={`Venue: ${event_venue}`} variant="body2" color="grey.100" width="80%" />
                            </Box>
                        </Box>

                        {/* Second child - only takes necessary width */}
                        <Box sx={{ display: "flex", p: "2px 10px", gap: 0.5, alignItems: "center", flexShrink: 0 }}>
                            <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "20px" }} />
                            
                             <Typography variant="body1">{event_price[0]?.price_with_discount}</Typography>
                            

                        </Box>
                    </Box>


                    <Button variant='outlined' fullWidth>Buy Now</Button>

                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default LatestEventCard;